
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    mapConfig: {
      type: Object,
      default: () => ({
        zoom: 8,
        center: { lat: -34.397, lng: 150.644 },
      }),
    },
    markers: {
      type: Array as () => Array<{ position: google.maps.LatLngLiteral }>,
      default: () => [],
    },
    google: {
      type: Array as unknown as PropType<[google.maps.PlacesLibrary, google.maps.MapsLibrary, google.maps.CoreLibrary, google.maps.MarkerLibrary]>,
      default: null,
    },
    
  },
  data() {
    return {
      map: null as google.maps.Map | null,
      marketsBound: null,
      googleMap: null as typeof google.maps.Map | null,
      googleLatLng: null as typeof google.maps.LatLngBounds | null,
    };
  },
  mounted() {
    this.initializeMap();
  },
  methods: {
    initializeMap():void {
      const [ PlacesLibrary, MapsLibrary, CoreLibrary] = this.google;
      this.googleMap = MapsLibrary.Map;
      this.googleLatLng = CoreLibrary.LatLngBounds;
      const GoogleLatLong = this.googleLatLng;

      const bounds = new GoogleLatLong() as google.maps.LatLngBounds;
      for (let i = 0; i < this.markers.length; i++) {
        bounds.extend(this.markers[i].position);
      }
      const mapContainer = this.$refs.googleMap;
      if (!this.googleMap) {
        return;
      }
      const Map = this.googleMap
      this.map = new Map(mapContainer as HTMLElement, this.mapConfig);
      this.map.fitBounds(bounds);
    },
  },
});
